const numberTranslations = {
	0: {
		es: "cero",
		en: "zero",
		fr: "zéro",
		de: "null",
		it: "zero",
	},
	1: {
		es: "uno",
		en: "one",
		fr: "un",
		de: "eins",
		it: "uno",
	},
	2: {
		es: "dos",
		en: "two",
		fr: "deux",
		de: "zwei",
		it: "due",
	},
	3: {
		es: "tres",
		en: "three",
		fr: "trois",
		de: "drei",
		it: "tre",
	},
	4: {
		es: "cuatro",
		en: "four",
		fr: "quatre",
		de: "vier",
		it: "quattro",
	},
	5: {
		es: "cinco",
		en: "five",
		fr: "cinq",
		de: "fünf",
		it: "cinque",
	},
	6: {
		es: "seis",
		en: "six",
		fr: "six",
		de: "sechs",
		it: "sei",
	},
	7: {
		es: "siete",
		en: "seven",
		fr: "sept",
		de: "sieben",
		it: "sette",
	},
	8: {
		es: "ocho",
		en: "eight",
		fr: "huit",
		de: "acht",
		it: "otto",
	},
	9: {
		es: "nueve",
		en: "nine",
		fr: "neuf",
		de: "neun",
		it: "nove",
	},
	10: {
		es: "diez",
		en: "ten",
		fr: "dix",
		de: "zehn",
		it: "dieci",
	},
	11: {
		es: "once",
		en: "eleven",
		fr: "onze",
		de: "elf",
		it: "undici",
	},
	12: {
		es: "doce",
		en: "twelve",
		fr: "douze",
		de: "zwölf",
		it: "dodici",
	},
	13: {
		es: "trece",
		en: "thirteen",
		fr: "treize",
		de: "dreizehn",
		it: "tredici",
	},
	14: {
		es: "catorce",
		en: "fourteen",
		fr: "quatorze",
		de: "vierzehn",
		it: "quattordici",
	},
	15: {
		es: "quince",
		en: "fifteen",
		fr: "quinze",
		de: "fünfzehn",
		it: "quindici",
	},
	16: {
		es: "dieciséis",
		en: "sixteen",
		fr: "seize",
		de: "sechzehn",
		it: "sedici",
	},
	17: {
		es: "diecisiete",
		en: "seventeen",
		fr: "dix-sept",
		de: "siebzehn",
		it: "diciassette",
	},
	18: {
		es: "dieciocho",
		en: "eighteen",
		fr: "dix-huit",
		de: "achtzehn",
		it: "diciotto",
	},
	19: {
		es: "diecinueve",
		en: "nineteen",
		fr: "dix-neuf",
		de: "neunzehn",
		it: "diciannove",
	},
	20: {
		es: "veinte",
		en: "twenty",
		fr: "vingt",
		de: "zwanzig",
		it: "venti",
	},
	// 21: {
	//   es: "veintiuno",
	//   en: "twenty-one",
	//   fr: "vingt et un",
	// },
	30: {
		es: "treinta",
		en: "thirty",
		fr: "trente",
		de: "dreißig",
		it: "trenta",
	},
	40: {
		es: "cuarenta",
		en: "forty",
		fr: "quarante",
		de: "vierzig",
		it: "quaranta",
	},
	50: {
		es: "cincuenta",
		en: "fifty",
		fr: "cinquante",
		de: "fünfzig",
		it: "cinquanta",
	},
	60: {
		es: "sesenta",
		en: "sixty",
		fr: "soixante",
		de: "sechzig",
		it: "sessanta",
	},
	70: {
		es: "setenta",
		en: "seventy",
		fr: "soixante-dix",
		de: "siebzig",
		it: "settanta",
	},
	80: {
		es: "ochenta",
		en: "eighty",
		fr: "quatre-vingts",
		de: "achtzig",
		it: "ottanta",
	},
	90: {
		es: "noventa",
		en: "ninety",
		fr: "quatre-vingt-dix",
		de: "neunzig",
		it: "novanta",
	},
	100: {
		es: "cien",
		en: "one hundred",
		fr: "cent",
		de: "hundert",
		it: "cento",
	},
	"100s": {
		es: "ciento",
		en: "one hundred",
		fr: "cent",
		de: "hundert",
		it: "cento",
	},
	500: {
		es: "quinientos",
		en: "five hundred",
		fr: "cinq cents",
		de: "fünfhundert",
		it: "cinquecento",
	},
	1000: {
		es: "mil",
		en: "one thousand",
		fr: "mille",
		de: "tausend",
		it: "mille",
	},
	1000000: {
		es: "millón",
		en: "one million",
		fr: "un million",
		de: "eine Million",
		it: "un milione",
	},
};

const languageProperties = {
	es: {
		thousand: "mil",
		hundred: "cientos",
		zero: "cero",
	},
	en: {
		thousand: "thousand",
		hundred: "hundred",
		zero: "zero",
	},
	fr: {
		thousand: "mille",
		hundred: "cent",
		zero: "zéro",
	},
	de: {
		thousand: "tausend",
		hundred: "hundert",
		zero: "null",
	},
	it: {
		thousand: "mille",
		hundred: "cento",
		zero: "zero",
	},
};

const getNumberTranslation = (n, language) => {
	const num = parseInt(n);
	if (isNaN(num)) return "";
	if (num > 999999) return n;
	if (numberTranslations[num]) return numberTranslations[num][language];

	const thousands = Math.floor(num / 1000);
	const rest = num % 1000;

	let result = "";
	if (thousands > 0) {
		if (thousands === 1) {
			result += `${numberTranslations[1000][language]}`;
		} else {
			result += `${getNumberTranslation(thousands, language)} ${
				languageProperties[language].thousand
			}`;
		}
	}
	result += `${getHundredTranslation(rest, language)}`;
	return filterZero(result.trim(), language);
};

const getHundredTranslation = (n, language) => {
	const hundreds = Math.floor(n / 100) * 100;
	const rest = n % 100;

	let result = "";
	if (hundreds > 0) {
		if (hundreds === 100) {
			result += `${numberTranslations["100s"][language]} `;
		} else if (hundreds === 500 && language === "es") {
			result += `${numberTranslations[500][language]} `;
		} else {
			result += `${numberTranslations[hundreds / 100][language]} ${
				languageProperties[language].hundred
			} `;
		}
	}
	result += `${getTensTranslation(rest, language)}`;
	return result.trim();
};

const getTensTranslation = (n, language) => {
	if (n <= 19 && n >= 10) return numberTranslations[n][language];
	if (n === 0) return "";

	let tens = Math.floor(n / 10) * 10;
	const units = n % 10;
	let result = "";

	if (language === "fr" && tens % 100 >= 90 && tens % 100 <= 99) {
		result += `${numberTranslations[80]["fr"]} ${
			numberTranslations[10 + units][language]
		}`;
	} else if (language === "fr" && tens % 100 >= 70 && tens % 100 <= 79) {
		result += `${numberTranslations[60]["fr"]} ${
			numberTranslations[10 + units][language]
		}`;
	} else {
		result += `${tens === 0 ? "" : numberTranslations[tens][language]} `;
		result += `${units === 0 ? "" : numberTranslations[units][language]}`;
	}

	return result.trim();
};
export default getNumberTranslation;

const filterZero = (n, lang) => {
	switch (lang) {
		case "es":
			return n.replace("cero", "");
		case "en":
			return n.replace("zero", "");
		case "fr":
			return n.replace("zéro", "");
		case "de":
			return n.replace("null", "");
		case "it":
			return n.replace("zero", "");
	}
};
